import {
  IAdminProgramCodeCreateNewPayload,
  IAdminProgramCodeFormValues,
} from '@interfaces/adminProgramCodes';

export const convertFormValuesToCreateNewPayload = (
  values: IAdminProgramCodeFormValues,
): IAdminProgramCodeCreateNewPayload => ({
  name: values.name,
  code: values.code,
  canUseDrugInquiry: values.canUseDrugInquiry,
  canUseDrugSearch: values.canUseDrugSearch,
  canUseSupplementInquiry: values.canUseSupplementInquiry,
  canUseEducation: values.canUseEducation,
  hasInOutCompBan: values.hasInOutCompBan,
  multiLanguage: values.multiLanguage,
  bannedText: values.bannedText,
  notBannedText: values.notBannedText,
  signupEmailHeader: values.signupEmailHeader,
  adminEmailHeader: values.adminEmailHeader,
  headlineText: values.headlineText,
  emailHeader: values.emailHeader,
  athleteRoleGroupId: values.athleteRoleGroupId,
  riskLevelDescriptionDtos: values.riskLevels.map(item => ({
    riskLevelId: item.riskLevelId,
    riskLevelDescriptionId: item.riskLevelDescriptionId,
  })),
  drugClassDtos: values.drugClasses,
  medicationNotFoundText: values.medicationNotFoundText || null,
  infoTileText: values.infoTileText || null,
  infoPageTitle: values.infoPageTitle || null,
  infoPageText: values.infoPageText || null,
});

export const validateForm = (values: IAdminProgramCodeFormValues) => {
  const errors: Partial<Record<keyof IAdminProgramCodeFormValues, string | boolean>> = {};

  if (!values.name) errors.name = true;
  if (!values.code) errors.code = true;
  if (!values.bannedText) errors.bannedText = true;
  if (!values.notBannedText) errors.notBannedText = true;
  if (!values.athleteRoleGroupId) errors.athleteRoleGroupId = true;
  if (values.riskLevels?.length !== 3) errors.riskLevels = true;

  return errors;
};
